module.exports = __webpack_public_path__ + "media/images/app/footer/pin-circle-1e22e9a7bcc1c0651dcdbf9870db4139.webp";